import { render, staticRenderFns } from "./groupTogeter.vue?vue&type=template&id=6ff8b1ee&scoped=true&"
import script from "./groupTogeter.vue?vue&type=script&lang=js&"
export * from "./groupTogeter.vue?vue&type=script&lang=js&"
import style0 from "./groupTogeter.vue?vue&type=style&index=0&id=6ff8b1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8b1ee",
  null
  
)

export default component.exports